import { getDatetimeText } from '@back-office/ui';
import { DateRange } from '@material-ui/pickers';
import { useLocalStore } from 'mobx-react';
import { MouseEvent } from 'react';
import { Store } from '.';
import useInject from '../../../hooks/useInject';

type UseViewModelReturn = {
  state: Store;
};

const useViewModel = (handleOnClose: () => void): UseViewModelReturn => {
  const { getTransactionCSV } = useInject((root) => root);

  const state = useLocalStore<Store>(() => ({
    date: [null, null],
    openCalendar: false,
    handleOnChangeDatePicker(date: DateRange<Date>) {
      this.date = date;
    },
    handleOnClear(event: MouseEvent<HTMLOrSVGElement>) {
      event.stopPropagation();
      this.openCalendar = false;
      this.date = [null, null];
      handleOnClose();
    },
    handleOnClickDatePicker() {
      this.date = [null, null];
      this.openCalendar = true;
    },
    handleOnCloseDatePicker() {
      if (this.date[0] && this.date[1]) {
        this.openCalendar = false;
      }
    },
    handleClose(event: MouseEvent<HTMLOrSVGElement>, reason: string) {
      if (reason === 'backdropClick') {
        this.openCalendar = false;
        state.handleOnClear(event);
      }
    },
    async handleOnExport() {
      if (this.date[0] && this.date[1]) {
        await getTransactionCSV(
          getDatetimeText(this.date[0], 'western'),
          getDatetimeText(this.date[1], 'western')
        ).finally(() => handleOnClose());
      }
      this.date = [null, null];
    },
  }));

  return {
    state,
  };
};

export default useViewModel;
